"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAvailableTabs = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const preferences_1 = require("@completeanatomy/preferences");
const selectAvailableTabs_1 = require("../selectors/selectAvailableTabs");
const useAvailableVideoTabs_1 = require("./useAvailableVideoTabs");
const useSelector_1 = require("./useSelector");
function useAvailableTabs(excludeExplode = false) {
    const availableTabs = (0, useSelector_1.useSelector)(selectAvailableTabs_1.selectAvailableTabs);
    const availableVideoTabs = (0, useAvailableVideoTabs_1.useAvailableVideoTabs)();
    const infoBoxTabOrder = (0, preferences_1.useInfoBoxTabsOrder)();
    const allTabs = [
        ...(excludeExplode
            ? availableTabs.filter(tab => tab !== bridge_schema_1.InfoBoxTabType.Explode)
            : availableTabs),
        ...availableVideoTabs,
    ];
    return [...infoBoxTabOrder, bridge_schema_1.InfoBoxTabType.Explode].filter(orderNum => allTabs.some(tabNum => tabNum === orderNum));
}
exports.useAvailableTabs = useAvailableTabs;
